import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ResponsesService {
  constructor(private http: HttpClient) {}

  getAction(idAction): Observable<any> {
    return this.http.get<any>(environment.apiUrl + '/v1/replies/' + idAction);
  }

  updateAction(idAction, data) {
    return this.http.put(environment.apiUrl + `/v1/replies/${idAction}`, {
      ...data,
    });
  }
}
